/* import __COLOCATED_TEMPLATE__ from './fly-switch.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
/**
  The FlySwitch component provides a simple toggle for on/off or enabled/disabled states in the app.
  The only required value is the `active` state, which is a simple boolean. You may further control
  state with `disabled` and `onChange`.

  ```hbs
  <FlySwitch
    \@active={{this.enabled}}
    \@disabled={{this.disabled}}
    \@onChange={{this.onChange}}
  />
  ```

  @class FlySwitch
  @public
 */
let FlySwitch = (_class = class FlySwitch extends Component {
  // This is for backwards compat. Ideally we wouldn't intercept the action and
  // let the parent handle the event.
  onChange(evt) {
    let value = evt.target.checked;
    this.args.onChange(value);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype)), _class);
export { FlySwitch as default };